import ListLoadController from "./list_load_controller";

export default class extends ListLoadController {
  static targets = ["message", "newLink"];

  hideNewLink() {
    if (!this.newLinkTarget.classList.contains("hidden")) {
      this.newLinkTarget.classList.add("hidden");
    }
  }

  showNewLink() {
    if (this.newLinkTarget.classList.contains("hidden")) {
      this.newLinkTarget.classList.remove("hidden");
    }
  }

  handleResponse(event) {
    let successMessage = event.target.dataset["message"];
    if(!successMessage) successMessage = "Success!";

    let toastEvent = null;

    if (event.detail[0].success) {
      this.loadList();
      toastEvent = new CustomEvent("show-toast", { detail: successMessage });

    } else {
      toastEvent = new CustomEvent("show-toast", { detail: "An error occurred:\n" + event.detail[0].error })
    }

    window.dispatchEvent(toastEvent);
  }

  cancelForm(event) {
    event.preventDefault();
    this.clearMessage();
    this.loadList();
  }

  clearMessage() {
    this.messageTarget.innerText = "";
  }
}